export const Noise = () => <div className="grain" aria-hidden="true" />;
